/* eslint-disable prettier/prettier */
import styled from "styled-components";

export const ParentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 900px;
  margin: 0 auto;
  font-family: "Roboto";
  font-style: normal;
`;

export const Header = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
`;

export const Greeting = styled.h1`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 20px;
  height: 100px;
  background: linear-gradient(269.86deg, rgba(6, 217, 134, 0.3) 0%, rgba(74, 118, 251, 0.3) 100%);
  border-radius: 15px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
  justify-content: center;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 20px;
    padding: 15px;
    height: auto;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between; /* Alinha os botões e o sistema bloqueado lado a lado */
  align-items: flex-start;
  width: 100%;
  background: #f0f8ff;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;

  /* Responsividade para telas menores */
  @media (max-width: 768px) {
    flex-direction: column; /* Empilha os elementos */
    align-items: center;
    gap: 20px; /* Espaçamento entre itens empilhados */
  }
`;

export const ActionsTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #555;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const ActionsCarousel = styled.div`
  display: flex;
  gap: 20px; /* Espaçamento entre os botões */

  @media (max-width: 768px) {
    flex-wrap: wrap; /* Permite que os botões quebrem linha */
    justify-content: center;
    gap: 15px;
  }
`;

export const ActionButton = styled.button`
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px 20px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 0px;
  width: 185px;
  height: 115px;

  &:hover {
    background: #e6f7ff;
  }

  i {
    font-size: 18px;
    color: #007bff;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px 16px;
  }
`;

export const SystemBlocked = styled.div`
  width: 200px;
  background: #ffe6e6;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  color: #ff4d4f;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const LockedIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 24px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
    font-size: 18px;
  }
`;

export const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  background: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
`;

export const EmailContact = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  a {
    color: #007bff;
    text-decoration: none;
    font-size: 16px;

    &:hover {
      text-decoration: underline;
    }
  }

  i {
    color: #007bff;
    font-size: 18px;
  }
`;

export const WhatsAppContact = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  span {
    font-size: 16px;
    color: #333;
  }

  i {
    color: #25d366; /* Cor do ícone do WhatsApp */
    font-size: 18px;
  }
`;
